import { render } from "./DragAndDropUploader.vue?vue&type=template&id=1f0f3c38&scoped=true&ts=true"
import script from "./DragAndDropUploader.vue?vue&type=script&lang=ts"
export * from "./DragAndDropUploader.vue?vue&type=script&lang=ts"

import "./DragAndDropUploader.vue?vue&type=style&index=0&id=1f0f3c38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0f3c38"]])

export default __exports__